<template>
  <v-autocomplete
    :value="value"
    :items="employeesList"
    :label="$t('EMPLOYEES.ITEM')"
    :search-input.sync="search"
    :item-text="getName"
    :counter="counter"
    :menu-props="menuProps"
    item-value="id"
    multiple
    chips
    small-chips
    deletable-chips
    append-outer-icon="mdi-close"
    v-bind="$attrs"
    v-on="listeners"
  >
    <template v-slot:prepend-item>
      <v-list-item ripple @mousedown.prevent @click="toggle">
        <v-list-item-action>
          <v-icon>
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            Select All
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-autocomplete>
</template>

<script>
import { isEqual, debounce } from 'lodash';
import { mapActions, mapState } from 'vuex';
import { mapCacheActions } from 'vuex-cache';
import clearableSelectFilter from '../filters/mixins/clearableSelectFilter';

const DEBOUNCE_DELAY = 250;

export default {
  name: 'EmployeesFilter',

  mixins: [clearableSelectFilter],

  props: {
    filters: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      localFilters: {}
    };
  },

  computed: {
    ...mapState('planning', ['employeesList']),

    issetValue() {
      return this.value.length > 0;
    },

    allEmployeesValue() {
      return this.employeesList.map(({ id }) => id);
    },

    isSelectedAll() {
      return this.employeesList.length === this.value.length;
    },

    isSomeSelected() {
      return this.issetValue && !this.isSelectedAll;
    },

    icon() {
      if (this.isSelectedAll) return 'mdi-close-box';
      if (this.isSomeSelected) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    }
  },

  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler: function(filters) {
        if (isEqual(filters, this.localFilters)) {
          return;
        }

        this.localFilters = {
          ...this.localFilters,
          ...filters
        };

        this.refreshData();
      }
    }
  },

  methods: {
    ...mapActions('planning', ['setEmployeesList']),
    ...mapCacheActions('planning', ['getEmployeesList']),

    refreshData: debounce(function debouncedRefreshData() {
      this.getEmployeesList({ params: this.localFilters })
        .then(response => {
          return { employees: response.data.data };
        })
        .then(this.setEmployeesList)
        .then(this.clearValuesIfNotExists);
    }, DEBOUNCE_DELAY),

    getName(item) {
      return `${item.first_name} ${item.last_name}`.trim();
    },

    clearValuesIfNotExists() {
      if (!this.issetValue) {
        return;
      }

      const values = this.employeesList
        .filter(i => this.value.includes(i.id))
        .map(({ id }) => id);

      this.emitter(values);
    },

    toggle() {
      if (this.isSelectedAll) {
        this.emitter([]);
      } else {
        this.emitter(this.allEmployeesValue);
      }
    }
  }
};
</script>

<style scoped></style>
